exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".nested-container {\n  margin-left: 20px; }\n  .nested-container > .TitleTextEditor {\n    margin-bottom: 10px; }\n", ""]);

// exports
